import { render, staticRenderFns } from "./ImprimirReceta.vue?vue&type=template&id=7be24396&scoped=true"
import script from "./ImprimirReceta.vue?vue&type=script&lang=js"
export * from "./ImprimirReceta.vue?vue&type=script&lang=js"
import style0 from "./ImprimirReceta.vue?vue&type=style&index=0&id=7be24396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be24396",
  null
  
)

export default component.exports